import React, { Component } from "react";
import "./comp-css/main.css";
//import _ from 'lodash';
import headerBg from "./img/header_bg.png";
import gopayImg from "./img/gopay/gopay.png";
import maestroImg from "./img/gopay/maestro.png";
import mastercardImg from "./img/gopay/mastercard.png";
import mastercardsecurecodeImg from "./img/gopay/mastercardsecurecode.png";
import verifiedbyvisaImg from "./img/gopay/verifiedbyvisa.png";
import visaImg from "./img/gopay/visa.png";
import visaelectronImg from "./img/gopay/visaelectron.png";

import Main from "./Main";
import { Link, withRouter } from "react-router-dom";
import ReactDOM from "react-dom";
import Settings from "./lib/settings";
import { connect } from "react-redux";
import * as Actions from "./actions";
import Helpers from "./lib/helpers";
//import {CSSTransitionGroup} from 'react-transition-group'

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSubcategory: "",
      categories: [],
      subcategory: [],
      infoItems: [],

      userItems: [],

      info: {
        street: "",
        city: "",
        ico: "",
        dic: "",
        tel: "",
        email: "",
      },
      mobileMenuVisible: false,
      categoriesMenuVisible: false,
      lastWindowWidth: 0,
      shopItems: [],
    };

    this.updateDimensions = this.updateDimensions.bind(this);
    this.onMobileMenuClick = this.onMobileMenuClick.bind(this);
    this.onMobileMenuItemClick = this.onMobileMenuItemClick.bind(this);
    this.onCategoriesMobileMenuClick = this.onCategoriesMobileMenuClick.bind(
      this
    );
    this.handleHeaderLoaded = this.handleHeaderLoaded.bind(this);
  }

  componentDidMount() {
    this.updateDimensions();

    window.addEventListener("resize", this.updateDimensions);

    fetch("/api/islogged", Settings.fetchParams("POST")).then((res) => {
      if (res.ok) {
        res.json().then((json) => {
          if (!json.error) {
            if (json.logged) {
              this.props.dispatch(
                Actions.loginAction(
                  json.user,
                  json.user.role === "admin"
                    ? Settings.adminUserMenu
                    : Settings.userMenu
                )
              );
              //this.props.dispatch(userLoginAction(json.user));
              this.setState({ userItems: [] });
            } else {
              this.props.dispatch(Actions.logoutAction(Settings.loginMenu));
              //this.props.dispatch(userLogoutAction())
            }
          }
        });
      }
    });

    fetch("/api/cart", Settings.fetchParams("GET")).then((res) =>
      res.json().then((json) => {
        if (typeof json.products !== "undefined") {
          this.props.dispatch(Actions.updateCart(json.products));
        }
      })
    );

    fetch("/api/info", Settings.fetchParams("GET")).then((res) =>
      res.json().then((json) => {
        if (typeof json.info !== "undefined") {
          this.setState({ info: json.info });
        }
      })
    );

    fetch("/api/articles", Settings.fetchParams("GET")).then((res) =>
      res.json().then((json) => {
        if (typeof json.articles !== "undefined") {
          this.setState({ infoItems: json.articles });
        }
      })
    );

    fetch("/api/categories/", Settings.fetchParams("GET"))
      .then((res) => res.json())
      .then((json) => {
        this.props.dispatch(Actions.categoryFetch(json));
        this.setMenuSelector(this.props);
      });

    //let menuPosition = ReactDOM.findDOMNode(this.refs.topMenu).clientHeight + ReactDOM.findDOMNode(this.refs.header).clientHeight;
    //this.props.dispatch(Actions.setMenuPosition(menuPosition));
  }

  handleHeaderLoaded() {
    let menuPosition =
      ReactDOM.findDOMNode(this.refs.topMenu).clientHeight +
      ReactDOM.findDOMNode(this.refs.header).clientHeight;
    this.props.dispatch(Actions.setMenuPosition(menuPosition));
  }

  updateDimensions() {
    let headerWidth = ReactDOM.findDOMNode(this.refs.header).offsetWidth;
    let HeaderWidthCoef = headerWidth / 900;
    let headerMargin = 50 * HeaderWidthCoef;

    if (headerWidth >= 900) {
      ReactDOM.findDOMNode(this.refs.userMenuItems).style.removeProperty(
        "display"
      );
      ReactDOM.findDOMNode(this.refs.categoriesMenu).style.removeProperty(
        "display"
      );
      ReactDOM.findDOMNode(
        this.refs.categoriesMobileMenuIco
      ).style.removeProperty("transform");
      // ReactDOM.findDOMNode(this.refs.userMenuItems).style.display = "block";
      // ReactDOM.findDOMNode(this.refs.categoriesMenu).style.display = "block";
      this.setState({ mobileMenuVisible: false, categoriesMenuVisible: false });
      // //this.setMenuSelector(this.props);
    } else {
      // ReactDOM.findDOMNode(this.refs.userMenuItems).style.display = "none";
      // ReactDOM.findDOMNode(this.refs.categoriesMenu).style.display = "none";
      // this.setState({mobileMenuVisible: false, categoriesMenuVisible: false});
    }

    ReactDOM.findDOMNode(this.refs.header).style.marginBottom =
      "-" + headerMargin + "px";
  }

  hideMenuSelector() {
    let menuSelector = ReactDOM.findDOMNode(this.refs.menuSelector);
    menuSelector.style.visibility = "hidden";
    menuSelector.style.opacity = 0;
    ReactDOM.findDOMNode(this.refs.subMenu).style.height = "0px";
  }

  setMenuSelector(props) {
    if (props.location.pathname === "/") {
      this.hideMenuSelector();
    }

    let paths = props.location.pathname.split("/");

    if (
      paths.length > 2 &&
      paths[1] === "category" &&
      paths[2] !== "" &&
      props.categories !== []
    ) {
      let selectedCat = props.categories.find((obj) => {
        return obj.slug === paths[2];
      });

      var haveChildrens;
      if (typeof selectedCat.parent === "undefined") {
        haveChildrens = props.categories.filter((obj) => {
          return obj.parent === selectedCat._id;
        });

        if (haveChildrens.length > 0) {
          this.onMenuItemClick(paths[2], haveChildrens);
        } else {
          this.onMenuItemClick(paths[2]);
        }
      } else {
        var selectedCatParent = props.categories.find((obj) => {
          return obj._id === selectedCat.parent;
        });

        haveChildrens = props.categories.filter((obj) => {
          return obj.parent === selectedCatParent._id;
        });

        if (haveChildrens.length > 0) {
          this.onMenuItemClick(selectedCatParent.slug, haveChildrens);
          this.setState({ selectedSubcategory: paths[2] });
        } else {
          this.onMenuItemClick(selectedCatParent.slug);
        }
      }
    } else {
      this.hideMenuSelector();
    }
  }

  onMobileMenuClick() {
    if (this.state.mobileMenuVisible) {
      ReactDOM.findDOMNode(this.refs.userMenuItems).style.display = "none";
      this.setState({ mobileMenuVisible: false });
    } else {
      ReactDOM.findDOMNode(this.refs.userMenuItems).style.display = "block";
      this.setState({ mobileMenuVisible: true });
    }
  }

  onMobileMenuItemClick() {
    let headerWidth = ReactDOM.findDOMNode(this.refs.header).offsetWidth;
    if (headerWidth < 900) {
      ReactDOM.findDOMNode(this.refs.userMenuItems).style.display = "none";
      ReactDOM.findDOMNode(this.refs.categoriesMenu).style.display = "none";
      ReactDOM.findDOMNode(this.refs.categoriesMobileMenuIco).style.transform =
        "rotate(-90deg)";
      this.setState({ mobileMenuVisible: false, categoriesMenuVisible: false });
    }
  }

  componentWillReceiveProps(newProps) {
    if (
      typeof this.props.location.pathname !== "undefined" &&
      typeof newProps.location.pathname
    ) {
      if (this.props.location.pathname !== newProps.location.pathname) {
        this.setMenuSelector(newProps);
      }
    }
  }

  onMenuItemClick(slug, subMenu) {
    let menuSelector = ReactDOM.findDOMNode(this.refs.menuSelector);
    menuSelector.style.width =
      ReactDOM.findDOMNode(this.refs[slug]).offsetWidth + "px";
    menuSelector.style.left =
      ReactDOM.findDOMNode(this.refs[slug]).offsetLeft + "px";
    menuSelector.style.visibility = "visible";
    menuSelector.style.opacity = 1;

    this.setState({ selectedSubcategory: "" });

    if (typeof subMenu === "undefined") {
      this.setState({ subcategory: [] });
      ReactDOM.findDOMNode(this.refs.subMenu).style.height = "0px";
    } else {
      this.setState({ subcategory: subMenu });
      ReactDOM.findDOMNode(this.refs.subMenu).style.height = "50px";
    }
  }

  onSubmenuItemClick(slug) {
    this.setState({ selectedSubcategory: slug });
  }

  onCategoriesMobileMenuClick() {
    if (this.state.categoriesMenuVisible) {
      ReactDOM.findDOMNode(this.refs.categoriesMenu).style.display = "none";
      ReactDOM.findDOMNode(this.refs.categoriesMobileMenuIco).style.transform =
        "rotate(-90deg)";
      this.setState({ categoriesMenuVisible: false });
    } else {
      ReactDOM.findDOMNode(this.refs.categoriesMenu).style.display = "block";
      ReactDOM.findDOMNode(this.refs.categoriesMobileMenuIco).style.transform =
        "rotate(0deg)";
      this.setState({ categoriesMenuVisible: true });
    }
  }

  render() {
    const tree = Helpers.createCategoryTree(this.props.categories);
    const Categories = tree.map((item, index) => (
      <Link
        to={"/category/" + item.slug}
        key={index}
        className="menuItemContainer"
        ref={item.slug}
        onClick={() => {
          this.onMenuItemClick(item.slug, item.subcategory);
          this.onMobileMenuItemClick();
        }}
      >
        {item.name}
      </Link>
    ));
    const subMenuItems = this.state.subcategory.map((item, index) => (
      <div key={index}>
        <Link
          to={"/category/" + item.slug}
          className={
            this.state.selectedSubcategory === item.slug
              ? "selectedSubcategory"
              : ""
          }
          ref={item.slug}
          onClick={() => this.onSubmenuItemClick(item.slug)}
        >
          {item.name}
        </Link>
      </div>
    ));

    const TopMenuUser = this.props.userMenu.map((item, index) => (
      <Link
        to={"/" + item.slug}
        key={index}
        className=""
        onClick={this.onMobileMenuItemClick}
      >
        {item.name}
      </Link>
    ));
    const TopMenuUserName = this.props.auth
      ? this.props.user.name + " " + this.props.user.surname
      : "Nepřihlášen";
    const FooterCat = tree.map((item, index) => (
      <ul key={index}>
        <li>
          <Link
            to={"/category/" + item.slug}
            key={index}
            onClick={() => {
              this.onMenuItemClick(item.slug, item.subcategory);
              window.scrollTo(0, this.props.menuPosition);
            }}
          >
            {item.name}
          </Link>
        </li>
      </ul>
    ));
    const FooterInfo = this.state.infoItems.map((item, index) => (
      <ul key={index}>
        <li>
          <Link to={"/article/" + item.slug} key={index}>
            {item.name}
          </Link>
        </li>
      </ul>
    ));
    const FooterUser = this.props.userMenu.map((item, index) => (
      <ul key={index}>
        <li>
          <Link to={"/" + item.slug} key={index}>
            {item.name}
          </Link>
        </li>
      </ul>
    ));

    const Cart = () => {
      return (
        <Link to="/cart/" className="menuCart">
          <i className="fas fa-shopping-cart"></i>
          {this.props.cart.total.toLocaleString()}
          Kč
        </Link>
      );
    };

    return (
      <div className="App" ref="app">
        {/*<div className="testAlert">TEST!</div>*/}
        <div
          className={
            this.props.loading ? "loader loaderShow" : "loader loaderHide"
          }
          ref="loader"
        ></div>
        <div className={this.props.loading ? "blurAnim blur5" : "blurAnim"}>
          <div className="topMenu" ref="topMenu">
            <div className="topMenuContainer">
              <div className="topMenuLeft">
                <i className="far fa-user"></i>
                {TopMenuUserName}
              </div>
              <div className="topMenuRight">
                <i
                  className="fas fa-bars mobileMenuButton"
                  onClick={this.onMobileMenuClick}
                ></i>
                <div className="userMenuItems" ref="userMenuItems">
                  {TopMenuUser}
                  {this.props.auth ? (
                    <i className="far fa-sign-out-alt"></i>
                  ) : (
                    <i className="far fa-sign-in-alt"></i>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div ref="header" className="header">
            <div className="headerBg" ref="headerBg"></div>
            <Link to="/" onClick={() => this.hideMenuSelector()}>
              <img
                src={headerBg}
                alt={"B.O.F.C. SARA"}
                onLoad={this.handleHeaderLoaded}
              />
            </Link>
          </div>
          <div className="pageWrapper">
            <div className="menu">
              <div className="menuItems">
                <div
                  className="categoriesMobileMenu"
                  ref="categoriesMobileMenu"
                  onClick={this.onCategoriesMobileMenuClick}
                >
                  Kategorie
                  <i
                    className="fas fa-sort-down"
                    ref="categoriesMobileMenuIco"
                  ></i>
                </div>
                {Cart()}
                <div className="clear clearMobileCategories"></div>
                <div className="categoriesMenu" ref="categoriesMenu">
                  {Categories}
                </div>

                <div className="menuSelector" ref="menuSelector">
                  <div className="menuSelectorArrow"></div>
                </div>
                <div className="clear"></div>
              </div>
            </div>
            <div className="subMenu" ref="subMenu">
              {subMenuItems}
            </div>
            <div className="content">
              {this.props.admin === 0 ? "" : <Main />}
            </div>

            <div className="footer">
              <div className="row">
                <div className="footerMenu">
                  <div className="footerMenuItems">
                    <h3>Kategorie</h3>
                    {FooterCat}
                  </div>
                  <div className="footerMenuItems">
                    <h3>Informace</h3>
                    {FooterInfo}
                  </div>
                  <div className="footerMenuItems">
                    <h3>Uživatel</h3>
                    {FooterUser}
                  </div>
                </div>
                <div className="vLine"></div>
                <div className="footerContat">
                  <h3>Provozovatel</h3>
                  <div className="footerAddress">
                    <i className="fas fa-map-marker-alt"></i>
                    <p>{this.state.info.street}</p>
                    <p>{this.state.info.city}</p>
                  </div>
                  <div className="footerCompany">
                    <i className="fas fa-building"></i>
                    <p>IČO: {this.state.info.ico}</p>
                    <p>DIČ: {this.state.info.dic}</p>
                  </div>
                  <div className="footerContactItems">
                    <i className="fas fa-envelope"></i>
                    <p>Tel: {this.state.info.tel}</p>
                    <p>E-mail: {this.state.info.email}</p>
                  </div>
                </div>
              </div>
              <div className="hLine"></div>
              <div className="row partners">
                {/*}<div className="footerSubscribe">
                Odběr novinek:
                <input type="text" placeholder="váš@email.cz"/>
              </div>*/}
                <a
                  href="http://www.banik.cz"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.banik.cz
                </a>
                <a
                  href="http://www.veterans-bofc.g6.cz"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.veterans-bofc.g6.cz
                </a>
                <a
                  href="http://www.banicek.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.banicek.com
                </a>
              </div>
              <div className="hLine"></div>
              {/* <div className="row gopayLogos">

              <img src={gopayImg} alt={"GoPay"} />
              <img src={maestroImg} alt={"Maestro"} />
              <img src={mastercardImg} alt={"Mastercard"} />
              <img src={mastercardsecurecodeImg} alt={"Mastercard Secure Code"} />
              <img src={verifiedbyvisaImg} alt={"Verified by Visa"} />
              <img src={visaImg} alt={"Visa"} />
              <img src={visaelectronImg} alt={"Visa Electron"} />

            </div>
            <div className="hLine"></div> */}
              <div className="row legalDiv">
                <div className="legalLine">
                  <div className="left">
                    Copyright © 2018 Studio Plesná, Všechna práva vyhrazena
                  </div>
                  <div className="right">Děkujeme za návštěvu!</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    auth: state.auth,
    user: state.user,
    userMenu: state.userMenu,
    loading: state.loading,
    scrollTo: state.scrollTo,
    admin: state.admin,
    menuPosition: state.menuPosition,
    cart: state.cart,
    categories: state.categories,
  };
}
export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// ./src/App.js